export default "__VITE_ASSET__D1Ypba81__"